<form #step5Form="ngForm" class="editForm customMat" validate>
    <div class="tab-pane fade in active">
        <div class="flex-center">
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step5Form);$event.preventDefault();">&#8592; &nbsp; zurück</button>
            <h4 class="sub">{{title}}</h4>
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" style="visibility: hidden;">&#8592; &nbsp; weiter</button>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row flex-strech">
                    <div class='col-xs-12'>
                        <div class="item">

                            <div class="flex-space-between">
                                <div>
                                    <div class="row">
                                        <div class='col-xs-12 col-sm-4'>
                                            <mat-form-field appearance="fill">
                                                <mat-label>Anrede</mat-label>
                                                <mat-select [(ngModel)]="step5.gender" name="gender" required>
                                                    <mat-option>--</mat-option>
                                                    <mat-option *ngFor="let gender of options" [value]="gender.value">
                                                        {{gender.value}}
                                                    </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                        </div>
                                        <div class='col-xs-12 col-sm-4'>
                                            <mat-form-field class="example-form-field">
                                                <mat-label>Vorname</mat-label>
                                                <input matInput type="text" minlength="4" pattern="[a-zA-Zäüö ]*" [(ngModel)]="step5.firstname" name="firstname" required>
                                              </mat-form-field>
                                        </div>
                                        <div class='col-xs-12 col-sm-4'>
                                            <mat-form-field class="example-form-field">
                                                <mat-label>Nachname</mat-label>
                                                <input matInput type="text" minlength="4" pattern="[a-zA-Zäüö ]*"  [(ngModel)]="step5.lastname" name="lastname" required>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class='col-xs-12 col-sm-6'>
                                            <mat-form-field class="example-form-field">
                                                <mat-label>E-Mail Adresse</mat-label>
                                                <input matInput type="email" [(ngModel)]="step5.email" name="email" [email]="true" required>
                                              </mat-form-field>
                                        </div>
                                        <div class='col-xs-12 col-sm-6'>
                                            <mat-form-field class="example-form-field">
                                                <mat-label>Telefonnummer</mat-label>
                                                <input matInput type="phone" [(ngModel)]="step5.phone" placeholder="555 555 1234" pattern="^[0-9]{7,20}$" name="phone" required>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class='col-xs-12 col-sm-6'>
                                            <mat-form-field class="example-form-field">
                                                <mat-label>Geburtsjahr</mat-label>
                                                <input matInput type="text" pattern="^(19)\d{2}$" [(ngModel)]="step5.birthyear" name="birthyear" maxlength="4" required>
                                              </mat-form-field>
                                        </div>
                                        <div class='col-xs-12 col-sm-6'>
                                            <mat-form-field appearance="fill">
                                                <mat-label>Woher kennen Sie uns?</mat-label>
                                                <mat-select [(ngModel)]="step5.source" name="source" required>
                                                    <mat-option>--</mat-option>
                                                    <mat-option *ngFor="let source of options2" [value]="source.value">
                                                        {{source.name}}
                                                    </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class='col-xs-12 col-sm-6' style="font-size: 1.2em;
                                        color: #999;
                                        margin: 0 0 1.5em 0; text-align: left;">
                                            <mat-checkbox [(ngModel)] = "checked" required name="checkbox1"></mat-checkbox>
                                            <span>Ich stimme der Kontaktaufnahme und Speicherung meiner gemachten Angaben durch die DEGIV zu. Weitere Informationen finden Sie in unserer <a href="https://www.degiv.de/datenschutz" target="_blank" style="color: #febf4d; text-decoration: none;">Datenschutzerklärung</a>. Ihre Einwilligung können Sie jederzeit widerrufen, schreiben Sie dazu einfach eine kurze E-Mail an info@degiv.de</span>
                                        </div>
                                        <div class='col-xs-12 col-sm-6'>
                                            <button mat-raised-button color="primary" class="submit-btn" [disabled]="!step5Form.valid" (click)="goToNext(step5Form)">Verrentungsermittlung erhalten<span>100% kostenlos & unverbindlich</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>      
            </div>
        </div>
        <div class="flex-center">
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step5Form);$event.preventDefault();">&#8592; &nbsp; zurück</button>
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" style="visibility: hidden;">&#8592; &nbsp; weiter</button>
        </div>
    </div>
  </form>
  <app-footer [progress]="95"></app-footer>